import { MessageSquare, Sparkles } from "lucide-react";

import { Button, EmptyState } from "@/components";

type EmptyChatProps = {
  /**
   * 고를 대화가 하나도 없는가.
   *
   * 예전에는 이 둘을 구분하지 않고 늘 "대화를 선택하세요"라고 했다. 방이 하나도
   * 없는 사람에게는 **고를 것이 없는데** 고르라고 한 셈이라, 처음 온 사람이 여기서
   * 막혔다. 이 앱이 뭘 하는 것인지도 화면 어디에서도 말해주지 않았다.
   */
  firstTime: boolean;
  onNewChat: () => void;
};

/** 아직 방을 고르지 않았을 때 대화창 자리를 채우는 것 */
export function EmptyChat({ firstTime, onNewChat }: EmptyChatProps) {
  if (firstTime) {
    return (
      <div className="flex flex-1 items-center justify-center bg-paper">
        <EmptyState
          size="md"
          icon={<Sparkles />}
          title="메일을 채팅처럼"
          // 이 한 줄이 이 앱을 쓸 이유의 전부다. 상대에게 앱을 깔라고 하지
          // 않아도 된다는 것을 처음부터 알려야 한다.
          description="여기서 보내는 말풍선 하나가 진짜 메일 한 통이에요. 상대는 Gmail이든 회사 메일이든, 늘 쓰던 메일함에서 그대로 받아요."
          actions={
            <Button size="sm" onClick={onNewChat}>
              첫 대화 시작하기
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div className="flex flex-1 items-center justify-center bg-paper">
      {/*
        "대화를 선택하세요"는 앱이 사용자에게 시키는 말투인데, 나머지 문구는
        전부 사실을 알려주는 해요체다. 제목은 "선택", 설명은 "고르다"로 낱말도 달랐다.
      */}
      <EmptyState
        icon={<MessageSquare />}
        title="아직 아무 대화도 열지 않았어요"
        description="왼쪽 목록에서 하나 고르면 여기에 열려요."
      />
    </div>
  );
}
